import type { AppRole } from "@/shared/store/authStore";

export function isElderlyUserRole(role?: AppRole | null) {
  return role === "user";
}

export function isProviderSideRole(role?: AppRole | null) {
  return role === "provider" || role === "admin" || role === "super_admin";
}

export function getRoleDisplayName(role?: AppRole | null) {
  const labels: Record<AppRole, string> = {
    admin: "Admin",
    provider: "Provider",
    super_admin: "Super Admin",
    user: "Elderly Person",
  };

  return role ? labels[role] : "Guest";
}

export function getPortalLabel(role?: AppRole | null) {
  const labels: Record<AppRole, string> = {
    admin: "Admin Portal",
    provider: "Provider Portal",
    super_admin: "Super Admin Portal",
    user: "Elderly People Portal",
  };

  return role ? labels[role] : "Care Portal";
}
